import { AreaOrSectorSaveDialogData, AreaOrSectorSaveDialogProps, LocationSelectData } from '../../types/inventory'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import React, { useContext, useMemo, useState } from 'react'
import { useMountEffect } from 'primereact/hooks'
import { RadioButton } from 'primereact/radiobutton'
import { CommonContext } from '../common/context/commonContext'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { isEmpty } from 'lodash'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

const AreaOrSectorSaveDialog = (props: AreaOrSectorSaveDialogProps) => {
    useMountEffect(() => {
        findMyArea()
    })

    const { $http, $toast } = useContext(CommonContext)
    const { t } = useTranslation()
    const [areas, setAreas] = useState<LocationSelectData[]>([])
    const [dropdownDisabled, setDropdownDisabled] = useState<boolean>(true)
    const [isDuplicate, setIsDuplicate] = useState<boolean>(false)
    const [isCheckedName, setIsCheckedName] = useState<boolean>(false)
    const [params, setParams] = useState<AreaOrSectorSaveDialogData>({
        type: 'AREA',
        areaId: '',
        nm: '',
    })

    const findMyArea = async () => {
        setAreas(
            await $http().get('/inventory/my-location', {
                params: {
                    type: 'Area',
                },
            }),
        )
    }

    const onClickAddLocation = async () => {
        const result = await $http().post('/inventory/location/add-location', params)

        if (result) {
            $toast({
                title: t(tokens.common.success),
                text: `로케이션 추가가 완료 되었습니다.`,
                icon: 'success',
            })

            props.onHide(true, params.type)
        }
    }

    const footer = () => {
        return (
            <div className="grid">
                <div className="col-6">
                    <Button
                        className="w-full p-button-secondary mt-4"
                        label={t(tokens.common.close)}
                        size="large"
                        onClick={() => props.onHide(false)}
                    />
                </div>
                <div className="col-6">
                    <Button
                        className="w-full p-button-info mt-4 col-6"
                        label={t(tokens.common.add)}
                        size="large"
                        onClick={onClickAddLocation}
                        disabled={isDisabled || !isCheckedName}
                    />
                </div>
            </div>
        )
    }

    const [debounceTypeCheck, setDebounceTypeCheck] = useState<any>()
    const onChangeTypeByValue = async (type: 'AREA' | 'SECTOR', value: string) => {
        const checkExistsType = () =>
            new Promise<boolean>((resolve) => {
                if (debounceTypeCheck) {
                    clearTimeout(debounceTypeCheck)
                }

                setDebounceTypeCheck(
                    setTimeout(async () => {
                        resolve(
                            await $http().get(`/inventory/location/exists-type`, {
                                params: {
                                    type: params.type,
                                    nm: value,
                                    areaId: params.areaId,
                                },
                            }),
                        )
                    }, 500),
                )
            })

        setIsDuplicate(await checkExistsType())
        setIsCheckedName(true)
    }
    const onChangeParams = async (type: string, value: string) => {
        if (type === 'type') {
            if (value === 'AREA') {
                setDropdownDisabled(true)
                params.areaId = ''
            } else {
                setDropdownDisabled(false)
            }
        }

        if (type === 'nm' && !isEmpty(value)) {
            setIsCheckedName(false)
            onChangeTypeByValue(params.type, value)
        }

        setParams({
            ...params,
            [type]: value,
        })
    }

    const isDisabled = useMemo(
        () => isEmpty(params.type) || isEmpty(params.nm) || (params.type === 'SECTOR' && isEmpty(params.areaId)) || isDuplicate,
        [params, isDuplicate],
    )

    return (
        <>
            <Dialog
                header="로케이션 추가"
                visible={props.visible}
                onHide={() => props.onHide(false)}
                closable={false}
                contentClassName="pb-0"
                footer={footer}
                style={{ width: '60vh' }}
            >
                <div className="grid">
                    <div className="col-12 flex">
                        <div className="wms-add-location-label font-bold text-primary required align-self-center">로케이션 구분</div>
                    </div>
                    <div className="col-12 flex">
                        <div className="flex align-items-center">
                            <div className="flex align-items-center" onClick={() => onChangeParams('type', 'AREA')}>
                                <RadioButton className="mb-0 mr-1" value="AREA" checked={params.type === 'AREA'} />
                                <label className="ml-">AREA</label>
                            </div>
                            <div className="flex align-items-center ml-5" onClick={() => onChangeParams('type', 'SECTOR')}>
                                <RadioButton className="ml-3" value="SECTOR" checked={params.type === 'SECTOR'} />
                                <label className="ml-2">SECTOR</label>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="wms-add-location-label font-bold text-primary required">Area 선택</div>
                    </div>
                    <div className="col-12">
                        <Dropdown
                            value={params.areaId}
                            className="flex p-inputtext-sm text-sm"
                            panelClassName="p-inputtext-sm"
                            optionValue="areaId"
                            optionLabel="areaNm"
                            placeholder="Area 선택"
                            options={areas}
                            onChange={(e) => onChangeParams('areaId', e.value)}
                            disabled={dropdownDisabled}
                        />
                    </div>
                    <div className="col-12">
                        <div className="wms-add-location-label font-bold text-primary required">로케이션 이름</div>
                    </div>
                    <div className="col-12">
                        <InputText
                            value={params.nm}
                            className="flex p-inputtext-sm text-sm w-full"
                            placeholder="로케이션 이름 입력"
                            onChange={(e) => onChangeParams('nm', e.currentTarget.value)}
                        />
                    </div>
                    {isDuplicate && <div className="ml-2 font-bold rdms-text-danger">로케이션 이름이 중복 되었습니다.</div>}
                </div>
            </Dialog>
        </>
    )
}

export default AreaOrSectorSaveDialog
